import moment from 'moment';
import { ActionStore, mailAttrFilterName, mailBoxOfDefer, mailBoxOfDeleted, mailBoxOfDraft, mailBoxOfFakeThread, mailBoxOfRdFlag, mailBoxOfSpam, mailBoxTable, mailContentFilterName, mailContentFolderFilterName, mailDbCommonQueryFilterName, mailOperationTable, mailTable, tpMailFilterName, mailBoxOfUnread, mailBoxOfFilterStar, mailBoxOfStar, } from './mail_action_store_model';
import { api } from '@/api/api';
import { apis } from '@/config';
import { getFolderStartContactId, getIsEncryptedMail, util } from '@/api/util';
import { MailAttactmentCacher } from './mail_attachment_cache';
import { edmMailHelper } from '@/api/util/edm_mail_helper';
import { setMailAttSource } from '@/api/utils';
const filterVisibleMailTags = (tags) => {
    if (!tags || tags.length === 0) {
        return undefined;
    }
    const visibleTags = tags.filter(tag => tag && !tag.startsWith('%') && !tag.endsWith('%'));
    return visibleTags.length > 0 ? visibleTags : undefined;
};
const defaultMailEntryInfo = {
    title: '',
    folder: 0,
    attachmentCount: 0,
    threadMessageCount: 0,
    replayed: false,
    forwarded: false,
    directForwarded: false,
    system: false,
    popRead: false,
    rcptSucceed: false,
    rcptFailed: false,
    content: {
        content: '',
        contentId: '',
    },
    id: '',
};
const MemberTypeMapper = {
    发送: 'to',
    抄送: 'cc',
    密送: 'bcc',
};
export class MailContentDbHelper {
    constructor(actions, modelHandler, contactHandler, subActions) {
        this.mailConfApi = api.requireLogicalApi(apis.mailConfApiImpl);
        this.actions = actions;
        this.subActions = subActions;
        this.systemApi = api.getSystemApi();
        this.modelHandler = modelHandler;
        this.contactHandler = contactHandler;
        this.db = api.getNewDBApi();
        this.mailApi = api.requireLogicalApi(apis.mailApiImpl);
        this.fileApi = api.getFileApi();
        this.storeApi = api.getDataStoreApi();
        this.errReportApi = api.requireLogicalApi(apis.errorReportImpl);
        this.eventApi = api.getEventApi();
        this.htmlApi = api.requireLogicalApi(apis.htmlApi);
        this.loggerHelper = api.requireLogicalApi(apis.loggerApiImpl);
        this.mailAttachmentCacher = new MailAttactmentCacher(this);
        ActionStore.dbEnable = true;
        this.contactApi = api.requireLogicalApi(apis.contactApiImpl);
    }
    setMailCachePath(path) {
        this.mailAttachmentCacher.setMailCachePath(path);
    }
    initDbEnable() {
        const sync = this.storeApi.getSync(ActionStore.dbEnableKey);
        if (sync && sync.suc && sync.data) {
            ActionStore.dbEnable = sync.data === 'true';
        }
    }
    setDbEnable(flag) {
        ActionStore.dbEnable = flag;
        this.storeApi.put(ActionStore.dbEnableKey, String(ActionStore.dbEnable)).then().catch(console.warn);
    }
    async doListMailBox(_account) {
        var _a;
        const data = await this.listMailBoxRawEntry(_account);
        if (!data) {
            return undefined;
        }
        data.forEach(item => {
            item.mailBoxUnread = item.mailBoxCurrentUnread;
            item.threadMailBoxUnread = item.threadMailBoxCurrentUnread;
        });
        let starListModels = [];
        if (!(process.env.BUILD_ISEDM || ((_a = this.systemApi.doGetProductInfo()) === null || _a === void 0 ? void 0 : _a.navigateVersion))) {
            const { starList } = await this.doListStarContact(_account);
            starListModels = starList;
        }
        const mailBoxModels = await this.modelHandler.handleCommonFolderRet(data, starListModels, _account);
        this.modelHandler.saveMailBoxContentToAction(mailBoxModels, data, _account);
        return mailBoxModels;
    }
    async listMailBoxRawEntry(_account) {
        let data;
        try {
            data = (await this.db.getByEqCondition(Object.assign(Object.assign({}, mailBoxTable), { _dbAccount: _account }), _account));
            if (!data || data.length === 0) {
                return undefined;
            }
        }
        catch (e) {
            console.warn('check db mailbox failed:', e);
            return undefined;
        }
        return data;
    }
    buildQuery(param, _account) {
        const query = this.buildCondition(param);
        if (query) {
            const isRealList = this.mailConfApi.getIsUseRealListSync();
            if (query.adCondition) {
                if (isRealList && this.db.getByRangeConditionWithTotalCount) {
                    return this.db.getByRangeConditionWithTotalCount(query, _account);
                }
                return this.db.getByRangeCondition(query, _account);
            }
            if (isRealList && this.db.getByEqConditionWithTotal) {
                return this.db.getByEqConditionWithTotal(query, _account);
            }
            return this.db.getByEqCondition(query, _account);
        }
        return Promise.reject(new Error('尚未实现'));
    }
    buildDeferMailCondition(param) {
        var _a;
        const [startTimeStr, endTimeStr] = ((_a = param.filter) === null || _a === void 0 ? void 0 : _a.defer) ? param === null || param === void 0 ? void 0 : param.filter.defer.split(':') : [];
        const startTime = startTimeStr ? moment(startTimeStr).startOf('day').valueOf() : 0;
        const endTime = endTimeStr ? moment(endTimeStr).endOf('day').valueOf() : Number.MAX_VALUE;
        const adCondition = {
            field: ['isThread', 'isDefer', 'deferTime', 'rcTime'],
            type: 'between',
            args: [[0, 1, startTime], [0, 1, endTime], true, true],
        };
        return Object.assign({ start: param.index, count: param.count, adCondition }, mailTable.status);
    }
    buildCondition(param) {
        var _a;
        const isThread = param.checkType === 'checkThread' ? 1 : 0;
        let query;
        if (param.id === mailBoxOfDefer.id) {
            return this.buildDeferMailCondition(param);
        }
        if (param.id && !param.filter && !param.status) {
            if (param.id === mailBoxOfRdFlag.id) {
                const adCondition = isThread
                    ? {
                        field: ['isThread', 'folder', 'redFlag', 'rcTime'],
                        type: 'between',
                        args: [[1, mailBoxOfFakeThread.id, 1, -Number.MAX_VALUE], [1, mailBoxOfFakeThread.id, 1, 0], true, true],
                    }
                    : {
                        field: ['isThread', 'redFlag', 'rcTime'],
                        type: 'between',
                        args: [[0, 1, -Number.MAX_VALUE], [0, 1, 0], true, true],
                    };
                query = Object.assign({ start: param.index, count: param.count, adCondition, filter: mailContentFilterName }, mailTable.status);
            }
            else if (param.id === mailBoxOfUnread.id) {
                const adCondition = isThread
                    ? {
                        field: ['isThread', 'folder', 'readStatus', 'rcTime'],
                        type: 'between',
                        args: [[1, mailBoxOfFakeThread.id, 0, -Number.MAX_VALUE], [1, mailBoxOfFakeThread.id, 0, 0], true, true],
                    }
                    : {
                        field: ['isThread', 'readStatus', 'rcTime'],
                        type: 'between',
                        args: [[0, 0, -Number.MAX_VALUE], [0, 0, 0], true, true],
                    };
                query = Object.assign({ start: param.index, count: param.count, adCondition, filter: mailContentFolderFilterName }, mailTable.status);
            }
            else if (param.topFlag === 'top') {
                query = Object.assign({ start: param.index, count: param.count, desc: param.desc, adCondition: {
                        field: ['isThread', 'folder', 'rank', 'rcTime'],
                        type: 'between',
                        args: [[isThread, param.id, -11, -Number.MAX_VALUE], [isThread, param.id, 0, 0], true, true],
                    } }, mailTable.status);
            }
            else {
                query = Object.assign({ start: param.index, count: param.count, desc: param.desc, adCondition: {
                        field: ['isThread', 'folder', 'rcTime'],
                        type: 'between',
                        args: [[isThread, param.id, -Number.MAX_VALUE], [isThread, param.id, 1], true, true],
                    } }, mailTable.status);
            }
        }
        else if (param.status) {
            const ret = {
                type: 'between',
            };
            if (param.status === 'read') {
                if (param.id) {
                    ret.field = ['isThread', 'folder', 'readStatus'];
                    ret.args = [[isThread, param.id, 1], [isThread, param.id, 1], true, true];
                }
                else {
                    ret.field = ['isThread', 'readStatus'];
                    ret.args = [[isThread, 1], [isThread, 1], true, true];
                }
            }
            else if (param.status === 'unread') {
                if (param.id) {
                    ret.field = ['isThread', 'folder', 'readStatus'];
                    ret.args = [[isThread, param.id, 0], [isThread, param.id, 0], true, true];
                }
                else {
                    ret.field = ['isThread', 'readStatus'];
                    ret.args = [[isThread, 0], [isThread, 0], true, true];
                }
            }
            else if (param.status === 'redFlag') {
                if (param.id) {
                    ret.field = ['isThread', 'folder', 'redFlag'];
                    ret.args = [[isThread, param.id, 1], [isThread, param.id, 1], true, true];
                }
                else {
                    ret.field = ['isThread', 'redFlag'];
                    ret.args = [[isThread, 1], [isThread, 1], true, true];
                }
            }
            query = Object.assign({ start: param.index, count: param.count, adCondition: ret }, mailTable.status);
        }
        else if (param.id && param.filter) {
            let field = ['isThread', 'folder', '', 'rcTime'];
            const args = [[isThread, param.id, 0, -Number.MAX_VALUE], [isThread, param.id, 0, 0], true, true];
            const type = 'between';
            if (param.filter.label0) {
                field[2] = 'redFlag';
                args[0][2] = 1;
                args[1][2] = 1;
            }
            else if (((_a = param.filter.flags) === null || _a === void 0 ? void 0 : _a.read) === false) {
                field[2] = 'readStatus';
                args[0][2] = 0;
                args[1][2] = 0;
            }
            else if (param.filter.preferred === 0) {
                field[2] = 'preferred';
                args[0][2] = 0;
                args[1][2] = 0;
            }
            else if (param.filter.sentDate) {
                field[2] = 'rank';
                args[0][2] = 0;
                args[1][2] = 0;
                args[0][3] = -Date.parse(param.filter.sentDate[1]);
                args[1][3] = -Date.parse(param.filter.sentDate[0]);
            }
            field = field.filter(v => !!v);
            query = Object.assign({ start: param.index, desc: param.desc, count: param.count, adCondition: { field, type, args } }, mailTable.status);
        }
        if (!param.id && !param.ids && param.tag) {
            query = Object.assign(Object.assign({ start: param.index, count: Math.min(param.count, 1000), adCondition: {
                    field: 'tags',
                    type: 'anyOf',
                    args: param.tag,
                }, order: 'rcTime', orderUsingIndex: false, filter: mailDbCommonQueryFilterName }, mailTable.status), { additionalData: {
                    isThread,
                } });
        }
        if (param.ids) {
        }
        return query;
    }
    async doListMailEntry(param, _account) {
        var _a;
        let data;
        try {
            console.log('checkStarMail', param);
            if (!param.checkType || ['normal', 'checkThread', 'checkStarMail'].includes(param.checkType) || edmMailHelper.isEdmMailReq(param.checkType)) {
                let mids;
                let totalCount = null;
                if (Array.isArray(param === null || param === void 0 ? void 0 : param.subEmails) && !!param.subEmails.filter(Boolean).length) {
                    return this.doListMailEntryDBByAccounts(param, _account);
                }
                if (param.mids && param.mids.length > 0) {
                    mids = param.mids;
                }
                else if ((process.env.BUILD_ISEDM || ((_a = this.systemApi.doGetProductInfo()) === null || _a === void 0 ? void 0 : _a.navigateVersion)) && edmMailHelper.isEdmMailReq(param.checkType)) {
                    return this.doListCustomerMailBoxEntities(param);
                }
                else if (param.checkType === 'checkStarMail') {
                    mids = await this.doListStarMailBoxEntities(param, _account);
                }
                else {
                    const entriesPromise = this.buildQuery(param, _account);
                    const queryResult = await entriesPromise;
                    let result = Array.isArray(queryResult) ? queryResult : queryResult.data;
                    if (!Array.isArray(queryResult) && queryResult && queryResult.totalCount) {
                        totalCount = queryResult.totalCount;
                    }
                    result = result.filter(v => !!v);
                    if (result && result.length > 0) {
                        mids = result.map(it => it.mid);
                    }
                }
                const mailEntryModels = mids && mids.length > 0
                    ? await this.getMailById({
                        id: mids,
                        noContent: true,
                        noContactRace: param.noContactRace,
                        _account: param._account,
                    })
                    : [];
                data = {
                    count: param.count,
                    index: param.index || 0,
                    query: param,
                    total: totalCount || mailEntryModels.length,
                    data: mailEntryModels.map(it => this.makeModelSafe(it)),
                    building: -1,
                };
            }
        }
        catch (e) {
            console.warn('check db mailEntry failed:', e);
            return undefined;
        }
        return data;
    }
    async doListMailEntryDBByAccounts(_param, _account) {
        let data;
        try {
            if (Array.isArray(_param === null || _param === void 0 ? void 0 : _param.subEmails) && !!_param.subEmails.filter(Boolean).length) {
                const param = Object.assign(Object.assign({}, _param), { index: 0, count: ((_param === null || _param === void 0 ? void 0 : _param.index) || 0) + _param.count });
                const subEmails = _param.subEmails.filter(Boolean);
                const allEntriesPromise = subEmails.map(account => this.buildQuery(param, account));
                const allQueryResult = await Promise.all(allEntriesPromise);
                const map = new Map();
                let totalCount = 0;
                allQueryResult.forEach((result, idx) => {
                    const data = Array.isArray(result) ? result : result.data;
                    if (!Array.isArray(result) && result && result.totalCount) {
                        totalCount += result.totalCount || 0;
                    }
                    map.set(subEmails[idx], data.filter(Boolean).map(it => it.mid));
                });
                const mailEntryModelsPromise = subEmails.map(account => {
                    const mids = map.get(account);
                    if (mids && mids.length > 0) {
                        return this.getMailById({
                            id: mids,
                            noContent: true,
                            noContactRace: param.noContactRace,
                            _account: account,
                        });
                    }
                    return Promise.resolve([]);
                });
                const allMailEntryModels = await Promise.all(mailEntryModelsPromise);
                const mailEntryModels = allMailEntryModels.flat(1).sort((a, b) => moment(b.entry.receiveTime).valueOf() - moment(a.entry.receiveTime).valueOf());
                data = {
                    count: param.count,
                    index: param.index || 0,
                    query: param,
                    total: totalCount || mailEntryModels.length,
                    data: mailEntryModels.slice(param.index, param.index + param.count).map(it => this.makeModelSafe(it)),
                    building: -1,
                };
            }
        }
        catch (e) {
            console.warn('doListMailEntryDBByAccounts failed:', e);
            return undefined;
        }
        return data;
    }
    doListCustomerMailBoxEntities(param) {
        const currentUser = this.systemApi.getCurrentUser();
        const { attrQuery } = param;
        if (!currentUser || !attrQuery || (Array.isArray(attrQuery) && attrQuery.length === 0)) {
            return Promise.resolve({
                count: param.count || 0,
                index: param.index || 0,
                query: param,
                total: 0,
                data: [],
                building: -1,
            });
        }
        return Promise.resolve({
            count: param.count || 0,
            index: param.index || 0,
            query: param,
            total: 0,
            data: [],
            building: -1,
        });
    }
    async doListStarMailBoxEntities(param, _account) {
        var _a, _b, _c, _d;
        console.log('doListStarMailBoxEntities');
        if (!param.id || !this.modelHandler.isValidStarFolderId(param.id)) {
            throw new Error('星标联系人邮件本地查询参数错误');
        }
        if (!param.attrConf) {
            const attrConf = await this.modelHandler.doGetStarContactQuery(param.id, _account);
            param.attrConf = Object.assign(Object.assign({}, attrConf), { attrType: 'star' });
        }
        const { id, emailList, attrValue } = param.attrConf;
        if (!id || emailList.length === 0) {
            return [];
        }
        let adCondition;
        let adQuery;
        if (((_b = (_a = param.filter) === null || _a === void 0 ? void 0 : _a.flags) === null || _b === void 0 ? void 0 : _b.read) === undefined) {
            const accountAlias = this.systemApi.getCurrentUserAccountAlias(_account);
            const currentUser = this.systemApi.getCurrentUser(_account);
            const currentId = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) ? [currentUser === null || currentUser === void 0 ? void 0 : currentUser.id] : [];
            adCondition = {
                field: ['attrType', 'attrValue', 'rcTime'],
                type: 'between',
                args: [['star', attrValue, -Number.MAX_VALUE], ['star', attrValue, 0], true, true],
            };
            adQuery = Object.assign({ start: param.index || 0, count: param.count || 30, adCondition, additionalData: {
                    exchangeType: (_c = param.attrQueryFilter) === null || _c === void 0 ? void 0 : _c.type,
                    filterValue: accountAlias.length > 0 ? accountAlias : currentId,
                }, filter: mailAttrFilterName }, mailTable.attr);
        }
        else {
            const readStatus = ((_d = param.filter) === null || _d === void 0 ? void 0 : _d.read) ? 1 : 0;
            adCondition = {
                field: ['attrType', 'attrValue', 'readStatus', 'rcTime'],
                type: 'between',
                args: [['star', attrValue, readStatus, -Number.MAX_VALUE], ['star', attrValue, readStatus, 0], true, true],
            };
            adQuery = Object.assign({ start: param.index || 0, count: param.count || 30, adCondition }, mailTable.attr);
        }
        return this.db.getByRangeCondition(adQuery, _account).then(res => {
            console.log('[mails attr] db query res', res);
            return res.map(v => v.mid);
        });
    }
    makeModelSafe(entry) {
        entry.entry.content = entry.entry.content || {
            content: '',
            contentId: '',
        };
        entry.receiver = entry.receiver || [];
        entry.sender = entry.sender || this.contactHandler.buildEmptyContact(false)[0];
        return entry;
    }
    async doGetMailContent(mid, noContactRace = false, _account) {
        try {
            const result = await this.getMailById({ id: mid, noContactRace, _account });
            if (result && result.length > 0 && !this.modelHandler.isEntryContentEmpty(result[0])) {
                return result[0];
            }
            return undefined;
        }
        catch (e) {
            console.warn('check db mailContent failed:', e);
            return undefined;
        }
    }
    async doGetTpMailContent(mid) {
        const result = await this.getTpMailById({ id: mid }).then(res => setMailAttSource(res, 'content'));
        if (result && result.length > 0 && !this.modelHandler.isEntryContentEmpty(result[0]) && !this.modelHandler.checkAttachmentUrl(result[0])) {
            return result[0];
        }
        return undefined;
    }
    async getMailContentTableInDb(mid, _account) {
        const content = await this.db.getById(mailTable.content, mid, _account);
        return content || {};
    }
    async syncTranslateContentToDb(mid, langType, conditions, _account) {
        var _a;
        const content = await this.getMailContentTableInDb(mid, _account);
        if (Object.keys(content).length === 0) {
            return false;
        }
        if (!((_a = content.langListMap) === null || _a === void 0 ? void 0 : _a.origin)) {
            content.langListMap.origin = content.title + MailContentDbHelper.translateSignTag + content.content;
        }
        if (conditions) {
            content.langListMap[langType] = conditions;
        }
        content.langType = langType;
        await this.db.put(mailTable.content, content, _account);
        return true;
    }
    async syncContentLangToDb(mid, originLang, _account) {
        const content = await this.getMailContentTableInDb(mid, _account);
        if (Object.keys(content).length === 0) {
            return false;
        }
        const langListMap = content.langListMap || {};
        langListMap.originLang = originLang;
        content.langListMap = langListMap;
        await this.db.put(mailTable.content, content, _account);
        return true;
    }
    async getThreadMessageByThreadMails(result, _account) {
        const threadMessageIds = result
            .filter(v => !!v)
            .reduce((total, current) => {
            if (current.isThread && Array.isArray(current.threadMessageIds)) {
                total.push(...current.threadMessageIds);
            }
            return total;
        }, []);
        const threadResult = (await this.db.getByIds(Object.assign(Object.assign({}, mailTable.status), { _dbAccount: _account }), [...new Set(threadMessageIds)]));
        return threadResult.filter(v => !!v);
    }
    async getThreadMessageByThreadIds(tids, _account) {
        if (!tids || tids.length === 0) {
            return {
                threadMails: [],
                threadMessages: [],
            };
        }
        const threadIds = tids.filter(v => !!v);
        const result = (await this.db.getByIds(Object.assign(Object.assign({}, mailTable.status), { _dbAccount: _account }), [...new Set(threadIds)], _account)).filter(v => !!v);
        let threadMails = [];
        let threadMessageResult = [];
        if (result && result.length > 0) {
            threadMessageResult = await this.getThreadMessageByThreadMails(result, _account);
            const { threadIds: ids } = this.extractThreadIds(result);
            threadMails = (await this.db.getByIds(mailTable.status, [...new Set(ids)], _account)).filter(v => !!v);
        }
        return {
            threadMails,
            threadMessages: threadMessageResult.filter(v => !!v),
        };
    }
    async classifyThreadMailsByIds(id, ignoreFakeThreadId, _account) {
        const inputIds = Array.isArray(id) ? id : [id];
        const result = (await this.db.getByIds(Object.assign(Object.assign({}, mailTable.status), { _dbAccount: _account }), inputIds, _account)).filter(v => !!v);
        const { threadIds, fakeThreadIds } = this.extractThreadIds(result, ignoreFakeThreadId);
        const foundIds = new Set(result.map(v => v.mid));
        const normalIdsFromFound = result.filter(v => v && !v.isThread).map(v => v.mid);
        const missingIds = inputIds.filter(inputId => !foundIds.has(inputId));
        const normalIds = [...normalIdsFromFound, ...missingIds];
        return {
            threadIds,
            normalIds,
            fakeThreadIds,
        };
    }
    extractThreadIds(result, ignoreFakeThreadId) {
        const fakeThreadIds = [];
        const filteredResult = result.filter(v => v && v.isThread);
        const reduceFunc = (total, current) => {
            let ret = total;
            if (current.convFids && current.convFids.length > 0) {
                const fakeIds = current.convFids.map(fid => util.getJointThreadId(current.threadId, fid));
                const children = ignoreFakeThreadId ? [] : fakeIds;
                fakeThreadIds.push(...fakeIds);
                const set = new Set([...total, ...children]);
                if (current.threadId) {
                    set.add(current.threadId);
                }
                if (set) {
                    ret = Array.from(set);
                }
            }
            return ret;
        };
        const threadIds = filteredResult.reduce(reduceFunc, []);
        return { threadIds, fakeThreadIds };
    }
    async doDeleteMail(param) {
        const { originData, fid, id, isThread, deletedId = [], moveId = [], _account, directDelete = false } = param;
        let result;
        let missingIds = [];
        if (id) {
            const checkIds = Array.isArray(id) ? id : [id];
            result = (await this.db.getByIds(Object.assign(Object.assign({}, mailTable.status), { _dbAccount: _account }), checkIds)).filter(v => !!v);
            const foundIds = new Set(result.map(item => item.mid));
            missingIds = checkIds.filter(checkId => !foundIds.has(checkId));
        }
        else if (fid) {
            result = (await this.db.getByEqCondition(Object.assign(Object.assign({ query: { folder: fid } }, mailTable.status), { _dbAccount: _account }), _account));
        }
        result = result ? result.filter(v => !!v) : [];
        if (result && result.length > 0) {
            if (fid) {
                const tempIds = [];
                result.forEach(v => {
                    if (v.isThread && v.threadId && v.mid.includes('--')) {
                        tempIds.push(v.threadId);
                    }
                });
            }
            if (isThread) {
                const threadResult = await this.getThreadMessageByThreadMails(result, _account);
                if (threadResult.length > 0) {
                    result.push(...threadResult);
                }
            }
            else if (!param.ignoreThread) {
                const resultWithThreadId = result.filter(v => v && v.threadId);
                const tempResult = [];
                for (const item of resultWithThreadId) {
                    if (item.threadId) {
                        const { threadMails } = await this.getThreadMessageByThreadIds([item.threadId], _account);
                        if (threadMails.length > 0) {
                            const threadMail = threadMails[0];
                            const { threadMessageIds } = threadMail;
                            if (!Array.isArray(threadMessageIds) || (threadMessageIds[0] === item.mid && threadMessageIds.length === 1)) {
                                tempResult.push(...threadMails);
                            }
                        }
                    }
                }
                result.push(...tempResult);
            }
            result.forEach(it => {
                if (directDelete) {
                    if (it.mid) {
                        deletedId.push(it.mid);
                    }
                    return;
                }
                if (it.folder === mailBoxOfDeleted.id) {
                    if (it.mid) {
                        deletedId.push(it.mid);
                    }
                }
                else {
                    if (it.mid) {
                        moveId.push(it.mid);
                    }
                    originData.push(Object.assign({}, it));
                }
            });
            if (missingIds.length > 0) {
                missingIds.forEach(missingId => {
                    if (directDelete) {
                        deletedId.push(missingId);
                    }
                    else {
                        moveId.push(missingId);
                    }
                });
            }
            return this.doMarkInDb({
                newData: result,
                type: 'folder',
                mark: true,
                fid: mailBoxOfDeleted.id,
                originData,
                isThread,
                _account,
            });
        }
        return [];
    }
    async deleteInActionById(deletedId, _account) {
        if (deletedId && deletedId.length > 0) {
            try {
                await this.deleteByIds(deletedId, _account);
            }
            finally {
                await this.modelHandler.notifyFolderCountChange(true, _account);
            }
        }
    }
    async doMarkMail(mark, id, type, isThread, payload, _account) {
        console.log('[mail mark]', type, id);
        const checkIds = Array.isArray(id) ? id : [id];
        const result = (await this.db.getByIds(mailTable.status, checkIds, _account)).filter(v => !!v);
        if (result && result.length > 0) {
            if (isThread) {
                if (type !== 'top') {
                    const threadResult = await this.getThreadMessageByThreadMails(result, _account);
                    result.push(...threadResult);
                }
            }
            else {
                const resultWithThreadId = result.filter(v => v.threadId).filter(v => !!v);
                const threadMailIds = resultWithThreadId.map(v => v.threadId);
                if (type === 'read') {
                    const tempResult = [];
                    for (const item of resultWithThreadId) {
                        const { threadMessages, threadMails } = await this.getThreadMessageByThreadIds([item.threadId], _account);
                        if (mark) {
                            const unreadThreadMessages = threadMessages.filter(v => v.readStatus === 0 && v.mid !== item.mid);
                            if (unreadThreadMessages.length === 0) {
                                console.log('[mail mark] ', id, ' mark thread same time', threadMails);
                                tempResult.push(...threadMails);
                            }
                            else {
                                console.log('[mail mark] ', id, ' unread messages', unreadThreadMessages);
                            }
                        }
                        else {
                            tempResult.push(...threadMails);
                        }
                    }
                    result.push(...tempResult);
                }
                if (type === 'redFlag' && mark) {
                    const { threadMails } = await this.getThreadMessageByThreadIds(threadMailIds, _account);
                    if (threadMails && threadMails.length > 0) {
                        result.push(...threadMails);
                    }
                }
            }
        }
        try {
            return await this.doMarkInDb({
                newData: result,
                type,
                mark,
                fid: -1000,
                isThread,
                payload,
                _account,
            });
        }
        finally {
        }
    }
    async doMarkMailDefer(mid, isDefer, conf, _account) {
        const ids = Array.isArray(mid) ? mid : [mid];
        const originData = (await this.db.getByIds(mailTable.status, ids, _account)).filter(v => !!v);
        if (originData && originData.length > 0) {
            const newData = originData.map(v => (Object.assign(Object.assign({}, v), { isDefer: isDefer ? 1 : 0, deferTime: isDefer && conf.deferTime && conf.deferTime > 0 ? conf.deferTime : undefined, deferNotice: isDefer && conf.deferNotice ? 1 : 0 })));
            const ret = (await this.db.putAll(mailTable.status, newData, undefined, _account));
            console.log('[mail] doMarkMailDefer save', ret);
            return ret;
        }
        return [];
    }
    async getMailLeastUpdated(fid, toTimestamp, fromTimestamp, count) {
        const field = ['folder', 'updateTime'];
        const args = [[fid, fromTimestamp], [fid, toTimestamp], true, true];
        return (await this.db.getByRangeCondition(Object.assign({ start: 0, count: count || 100, adCondition: {
                field,
                type: 'between',
                args,
            } }, mailTable.status)));
    }
    async doMarkMailInfFolder(mark, fid, isThread, _account) {
        const result = (await this.db.getByEqCondition(Object.assign({ query: {
                '[isThread+folder+readStatus]': [isThread ? 1 : 0, fid, mark ? 0 : 1],
            } }, mailTable.status), _account));
        if (result && result.length > 0 && isThread) {
            const threadIds = result.filter(v => v && v.isThread).map(v => v.mid);
            const tempResult = await this.getThreadMessageByThreadIds(threadIds, _account);
            const threadMails = tempResult.threadMails.filter(v => v && !threadIds.includes(v.mid));
            result.push(...threadMails);
            result.push(...tempResult.threadMessages);
        }
        return this.doMarkInDb({
            newData: result,
            type: 'read',
            mark,
            fid: -1000,
            isThread,
            _account,
        });
    }
    async doMarkInDb(conf) {
        const { newData, type, mark, fid, originData, _account, payload } = conf;
        if (newData && newData.length > 0) {
            const filterData = this.filterMarkResult(newData, type, mark, fid, payload);
            let ret = [];
            if (filterData && filterData.length > 0) {
                ret = (await this.db.putAll(Object.assign(Object.assign({}, mailTable.status), { _dbAccount: _account }), filterData));
                if (type === 'folder') {
                    const needDeleteAttrList = filterData.filter(({ folder }) => mailBoxOfFilterStar[folder]).map(v => v.mid);
                    if (needDeleteAttrList.length > 0) {
                        this.deleteMailAttrByMids(needDeleteAttrList).then();
                    }
                }
                console.log('[mail] doMarkInDb save', ret);
                if (type === 'read' || type === 'folder') {
                    await this.updateMailStat({
                        newData: filterData,
                        type,
                        mark,
                        fid,
                        originData,
                        isThread: conf.isThread,
                        _account,
                    });
                    if (type === 'read') {
                        const mids = newData.map(v => v.mid);
                        await this.updateStarMailStat({ mids, mark, _account });
                    }
                }
            }
            return ret;
        }
        return [];
    }
    async updateMailStat(conf) {
        var _a;
        const { newData, type, mark, fid, originData, _account } = conf;
        if (!newData || newData.length === 0) {
            return;
        }
        const targetActions = (_a = this.mailApi.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        const { mailBoxDic } = targetActions || {};
        if (!mailBoxDic) {
            return;
        }
        const changedFolderMap = new Map();
        if (type === 'read') {
            this.loggerHelper.track('mark_mail', { stage: 'update_mail_start', newData });
            newData.forEach(it => {
                const folderId = it.folder;
                const folder = mailBoxDic[folderId];
                if (folder) {
                    if (it.isThread) {
                        folder.threadMailBoxCurrentUnread += mark ? -1 : 1;
                        folder.threadMailBoxUnread += mark ? -1 : 1;
                    }
                    else {
                        folder.mailBoxCurrentUnread += mark ? -1 : 1;
                        folder.mailBoxUnread += mark ? -1 : 1;
                    }
                    const keys = ['threadMailBoxCurrentUnread', 'threadMailBoxUnread', 'mailBoxCurrentUnread', 'mailBoxUnread'];
                    keys.forEach(key => {
                        if (folder[key] < 0) {
                            console.error('[mail mark] < 0 type read', key, it, conf);
                            folder[key] = 0;
                        }
                    });
                    changedFolderMap.set(folderId, folder);
                }
            });
        }
        else if (type === 'folder') {
            if (!originData) {
                return;
            }
            const map = new Map();
            originData.forEach(it => {
                map.set(it.mid, it);
            });
            const toFolder = mailBoxDic[fid];
            if (toFolder) {
                toFolder.mailBoxTotal += newData.length;
                changedFolderMap.set(fid, toFolder);
                newData.forEach(it => {
                    const item = map.get(it.mid);
                    if (item) {
                        const fromFolder = mailBoxDic[item.folder];
                        if (fromFolder) {
                            fromFolder.mailBoxTotal -= 1;
                            const isDraftMailMove = [toFolder.mailBoxId, fromFolder.mailBoxId].includes(mailBoxOfDraft.id);
                            if (item.readStatus === 0 || isDraftMailMove) {
                                if (it.isThread) {
                                    fromFolder.threadMailBoxCurrentUnread -= 1;
                                    fromFolder.threadMailBoxUnread -= 1;
                                    toFolder.threadMailBoxCurrentUnread += 1;
                                    toFolder.threadMailBoxUnread += 1;
                                }
                                else {
                                    fromFolder.mailBoxCurrentUnread -= 1;
                                    fromFolder.mailBoxUnread -= 1;
                                    toFolder.mailBoxCurrentUnread += 1;
                                    toFolder.mailBoxUnread += 1;
                                }
                                const keys = ['threadMailBoxCurrentUnread', 'threadMailBoxUnread', 'mailBoxCurrentUnread', 'mailBoxUnread'];
                                keys.forEach(key => {
                                    if (fromFolder[key] < 0) {
                                        console.error('[mail mark] < 0 type folder', key, it, conf);
                                        fromFolder[key] = 0;
                                    }
                                });
                                changedFolderMap.set(item.folder, fromFolder);
                            }
                        }
                    }
                });
            }
            await this.updateThreadMailCount(newData, toFolder.mailBoxId, _account);
        }
        const changedFolder = [...changedFolderMap.values()].map(v => {
            ['mailBoxTotal', 'threadMailBoxTotal', 'mailBoxUnread', 'mailBoxCurrentUnread', 'threadMailBoxUnread', 'threadMailBoxCurrentUnread'].forEach(key => {
                if (v[key] < 0) {
                    console.error('[mail mark] < 0', key, v, conf);
                }
            });
            return Object.assign(Object.assign({}, v), { mailBoxTotal: Math.max(v.mailBoxTotal, 0), threadMailBoxTotal: Math.max(v.threadMailBoxTotal, 0), mailBoxUnread: Math.max(v.mailBoxUnread, 0), mailBoxCurrentUnread: Math.max(v.mailBoxCurrentUnread, 0), threadMailBoxUnread: Math.max(v.threadMailBoxUnread, 0), threadMailBoxCurrentUnread: Math.max(v.threadMailBoxCurrentUnread, 0) });
        });
        console.log('doMarkMail in api updateMailStat');
        await this.saveMailBoxes(changedFolder, _account);
        const folderRes = await this.doListMailBox(_account);
        this.eventApi.sendSysEvent({
            eventName: 'mailChanged',
            eventStrData: 'syncFolder',
            eventData: folderRes,
            toAccount: [this.systemApi.getMainAccount().email],
            _account,
        });
        if (type === 'read') {
            this.loggerHelper.track('mark_mail', { stage: 'update_mail_end', mark, changedFolder });
        }
        this.modelHandler.calFolderUnread(_account);
    }
    async updateStarMailStat(conf) {
        const { mids, mark, _account } = conf;
        const res = (await this.db.getByIndexIds(Object.assign({}, mailTable.attr), 'mid', mids, _account)).filter(v => !!v);
        if (res.length > 0) {
            const newData = res.map(v => (Object.assign(Object.assign({}, v), { readStatus: mark ? 1 : 0 })));
            await this.db.putAll(Object.assign({}, mailTable.attr), newData, undefined, _account);
        }
    }
    async updateThreadMailCount(data, mailBoxId, _account) {
        const idSet = new Set();
        const handledThreadMailStatus = [];
        const isDelete = +mailBoxId === 4;
        for (const it of data) {
            if (it.threadId && !it.isThread) {
                const threadMails = (await this.db.getByIds(Object.assign(Object.assign({}, mailTable.status), { _dbAccount: _account }), [it.threadId])).filter(v => !!v);
                if (threadMails.length > 0) {
                    const threadMail = threadMails[0];
                    const { threadMessageIds } = threadMail;
                    if (threadMessageIds && threadMessageIds.length > 0) {
                        const newThreadMessageIds = isDelete ? threadMessageIds.filter(tid => tid !== it.mid) : [...new Set([...threadMessageIds, it.mid])];
                        handledThreadMailStatus.push(Object.assign(Object.assign({}, threadMail), { threadMessageCount: newThreadMessageIds.length, threadMessageIds: newThreadMessageIds, threadMessageFirstId: newThreadMessageIds.length > 0 ? newThreadMessageIds[0] : '' }));
                    }
                    idSet.add(threadMail.mid);
                }
            }
        }
        this.putDataAndReserveFields({
            table: Object.assign(Object.assign({}, mailTable.status), { _dbAccount: _account }),
            idSet,
            data: handledThreadMailStatus,
            reserveKeys: ['headers', 'threadId', 'attachmentsZipPath'],
        }).then();
    }
    filterMarkResult(result, type, mark, fid, payload) {
        const newData = result
            .map(it => {
            if (type === 'redFlag') {
                if ((it.redFlag === 1) === mark) {
                    return undefined;
                }
                it.redFlag = mark ? 1 : 0;
            }
            else if (type === 'preferred') {
                if ((it.preferred === 0) === mark) {
                    return undefined;
                }
                it.preferred = mark ? 0 : 1;
            }
            else if (type === 'read') {
                if ((it.readStatus === 1) === mark) {
                    return undefined;
                }
                it.readStatus = mark ? 1 : 0;
            }
            else if (type === 'folder') {
                if (it.folder === fid) {
                    return undefined;
                }
                it.folder = fid;
                it.rank = 0;
            }
            else if (type === 'top') {
                if ((it.rank === -10) === mark) {
                    return undefined;
                }
                it.rank = mark ? -10 : 0;
            }
            else if (type === 'requestReadReceiptLocal') {
                it.requestReadReceiptLocal = mark;
            }
            else if (type === 'memo') {
                it.memo = (payload === null || payload === void 0 ? void 0 : payload.memo) || '';
            }
            return it;
        })
            .filter(it => !!it);
        console.log('==== update db using filtered data:', newData);
        return newData;
    }
    async updateMailStatus(items, _account) {
        return this.db.putAll(Object.assign(Object.assign({}, mailTable.status), { _dbAccount: _account }), items);
    }
    async updateMessageTags(params, origin, isThread, _account) {
        if (!params || !params.ids || params.ids.length === 0) {
            return undefined;
        }
        const mails = (await this.db.getByIds(mailTable.status, params.ids, _account)).filter(v => !!v);
        if (mails && mails.length > 0) {
            if (isThread) {
                const threadMessages = await this.getThreadMessageByThreadMails(mails, _account);
                if (threadMessages && threadMessages.length > 0) {
                    mails.push(...threadMessages);
                }
            }
            else if (params.add && params.add.length > 0) {
                const threadMailIds = mails.map(v => v.threadId).filter(v => !!v);
                if (threadMailIds.length > 0) {
                    const threadMails = (await this.db.getByIds(mailTable.status, threadMailIds, _account)).filter(v => !!v);
                    if (threadMails && threadMails.length > 0) {
                        mails.push(...threadMails);
                    }
                }
            }
            mails.forEach(it => {
                origin.push(Object.assign({}, it));
                if (params.set && params.set.length > 0) {
                    it.tags = params.set;
                }
                if (params.add && params.add.length > 0) {
                    it.tags = (it.tags || []).concat(params.add);
                    it.tags = [...new Set(it.tags)];
                }
                if (params.delete && params.delete.length > 0) {
                    const tgSet = new Set(params.delete);
                    if (it.tags && it.tags.length > 0) {
                        it.tags = it.tags.filter(tg => !tgSet.has(tg));
                    }
                }
            });
            await this.db.putAll(mailTable.status, mails, undefined, _account);
        }
        return mails;
    }
    async doMoveMail(originData, id, fid, isThread, _account) {
        const checkIds = Array.isArray(id) ? id : [id];
        const result = (await this.db.getByIds(mailTable.status, checkIds, _account)).filter(v => !!v);
        originData.push(...result.map(v => (Object.assign({}, v))));
        return this.doMarkInDb({
            newData: result,
            type: 'folder',
            mark: true,
            fid,
            originData,
            isThread,
            _account,
        });
    }
    async getMailById(conf) {
        console.log('check mail from db:' + conf.id, conf);
        if (!conf.id) {
            return Promise.reject(new Error('参数未传入'));
        }
        if (!!conf.noStatus && !!conf.noData && !!conf.noContent) {
            return Promise.reject(new Error('需查询基础参数'));
        }
        const checkIds = Array.isArray(conf.id) ? conf.id : [conf.id];
        const result = new Map();
        const getMailData = !conf.noData ? this.db.getByIds(mailTable.data, checkIds, conf._account) : Promise.resolve(conf.mailData);
        const getMailStatus = !conf.noStatus
            ? this.db.getByIds(mailTable.status, checkIds, conf._account)
            : Promise.resolve(conf.statusData);
        const getMailAttachment = !conf.noAttachment
            ? this.db.getByIds(mailTable.attachment, checkIds, conf._account)
            : Promise.resolve(conf.attachData);
        const getMailContent = !conf.noContent
            ? this.db.getByIds(mailTable.content, checkIds, conf._account)
            : Promise.resolve(conf.contentData);
        const baseResult = await Promise.all([getMailData, getMailStatus, getMailContent, getMailAttachment]);
        this.buildMailModelByMailData(result, baseResult[0], conf._account);
        this.buildMailModelByMailStatus(result, baseResult[1]);
        this.buildMailModelByMailAttachment(result, baseResult[3], undefined, conf._account);
        await this.buildMailModelByMailContent(result, baseResult[2], conf._account);
        await this.buildMailContactByMailDataAndContent(result, baseResult[0], baseResult[2], !conf.noContact, conf.noContactRace, conf._account);
        return Array.from(result.values());
    }
    async getTpMailById(params) {
        const ids = Array.isArray(params.id) ? params.id : [params.id];
        const result = new Map();
        const getListPromise = () => this.db.getByIds(mailTable.tpMail, ids);
        const getContentPromise = params.noContent ? () => Promise.resolve([]) : () => this.db.getByIds(mailTable.tpMailContent, ids);
        const baseResult = await Promise.all([getListPromise(), getContentPromise()]);
        const listRes = baseResult[0].filter(v => !!v);
        const contentRes = baseResult[1].filter(v => !!v);
        if (Array.isArray(listRes) && listRes.length > 0) {
            listRes.forEach(v => {
                result.set(v.mid, v.entryModel);
            });
            contentRes.forEach(v => {
                const { entryModel, mid } = v;
                const listModel = result.get(mid);
                if (listModel && entryModel) {
                    const newModel = this.modelHandler.merge(listModel, entryModel);
                    result.set(v.mid, newModel);
                }
            });
            console.log('[get tpMail] no content', result);
        }
        return Array.from(result.values());
    }
    getTpMails(param) {
        const { from, toList, endTime, count, exchangeType } = param;
        const adCondition = {
            field: ['owner', 'rcTime'],
            type: 'between',
            args: [[from, typeof endTime === 'number' && endTime !== 0 ? -(endTime - 100) : -Number.MAX_VALUE], [from, 0], true, true],
        };
        const query = Object.assign({ count,
            adCondition, additionalData: {
                exchangeType,
                toList,
                from,
            }, filter: tpMailFilterName }, mailTable.tpMail);
        return this.db.getByRangeCondition(query).then(res => {
            console.log('[tp mails query] from db', param, res);
            return res.map(v => ({
                rcTime: v.rcTime,
                mid: v.mid,
                isTpMail: true,
            }));
        });
    }
    async buildMailContactByMailDataAndContent(result, baseEntity, contentEntity, checkContact, noContactRace = false, _account) {
        if (!result || ((!baseEntity || baseEntity.length === 0) && (!contentEntity || contentEntity.length === 0))) {
            return;
        }
        const allContact = new Map();
        if (baseEntity && baseEntity.length > 0) {
            baseEntity.forEach(it => {
                if (it && it.mid && it.contactData) {
                    allContact.set(it.mid, it.contactData);
                }
            });
        }
        if (contentEntity && contentEntity.length > 0) {
            contentEntity.forEach(it => {
                if (it && it.mid && it.contactData) {
                    allContact.set(it.mid, it.contactData);
                }
            });
        }
        allContact.forEach(v => {
            if (v && v.length) {
                v.forEach(it => {
                    it.type = it.type in MemberTypeMapper ? MemberTypeMapper[it.type] : it.type;
                });
            }
        });
        await this.buildMailContactData(allContact, result, checkContact, noContactRace, _account);
    }
    async buildMailContactData(allContact, result, checkContact, noContactRace = false, _account) {
        if (checkContact) {
            const allCheckedContact = [];
            allContact.forEach(val => {
                allCheckedContact.push(...val);
            });
            const models = await this.contactHandler.handleContactRawList(allCheckedContact, noContactRace, _account);
            allContact.forEach((val, key) => {
                const mailEntryModel = result.get(key);
                if (mailEntryModel) {
                    mailEntryModel.receiver = mailEntryModel.receiver || [];
                    if (val && val.length > 0) {
                        val.forEach(it => {
                            var _a;
                            const itemForUse = Object.assign(Object.assign({}, models[it.email + it.type]), { originName: it.name, mailMemberType: it.type });
                            if (itemForUse) {
                                if (it.type === '') {
                                    mailEntryModel.sender = itemForUse;
                                    if (!mailEntryModel.senders) {
                                        mailEntryModel.senders = [];
                                    }
                                    (_a = mailEntryModel.senders) === null || _a === void 0 ? void 0 : _a.push(itemForUse);
                                }
                                else {
                                    mailEntryModel.receiver.push(itemForUse);
                                }
                            }
                        });
                    }
                }
            });
        }
        else {
            allContact.forEach((val, key) => {
                const mailEntryModel = result.get(key);
                if (mailEntryModel) {
                    mailEntryModel.receiver = mailEntryModel.receiver || [];
                    if (val && val.length > 0) {
                        val.forEach(it => {
                            var _a;
                            const contactModel = this.contactHandler.buildRawContactItem(it);
                            if (it.type === '') {
                                mailEntryModel.sender = contactModel;
                                if (!mailEntryModel.senders) {
                                    mailEntryModel.senders = [];
                                }
                                (_a = mailEntryModel.senders) === null || _a === void 0 ? void 0 : _a.push(contactModel);
                            }
                            else {
                                contactModel.mailMemberType = it.type;
                                mailEntryModel.receiver.push(contactModel);
                            }
                        });
                    }
                }
            });
        }
    }
    async buildMailModelByMailContent(result, entity, _account) {
        var _a;
        if (!entity || entity.length === 0) {
            return;
        }
        for (let i = 0; i < entity.length; i++) {
            const it = entity[i];
            if (it && it.mid) {
                const { mid } = it;
                const mailModel = result.get(mid) || {};
                mailModel.id = mid;
                const entry = {
                    title: it.title,
                    brief: it.brief || ((_a = mailModel.entry) === null || _a === void 0 ? void 0 : _a.brief),
                    content: {
                        content: it.content,
                        contentId: it.contentId,
                        isHtml: it.isHtml,
                        encoding: it.encoding || 'default',
                    },
                    langType: it.langType || '',
                    langListMap: it.langListMap || {},
                };
                mailModel.entry = Object.assign(Object.assign(Object.assign({}, defaultMailEntryInfo), mailModel.entry), entry);
                mailModel.antispamInfo = it.antispamInfo;
                if (it.content && it.content.length > 0 && entry.content) {
                    await this.modelHandler.handleMailContentReplace(mailModel, 'readMailFromDb', undefined, undefined);
                }
                result.set(mid, mailModel);
            }
        }
    }
    buildMailModelByMailAttachment(result, entity, noCloudAttachment, _account) {
        if (!entity || entity.length === 0) {
            return;
        }
        const currentUser = this.systemApi.getCurrentUser(_account);
        if (!currentUser) {
            throw new Error('用户未登录？');
        }
        const subAccount = this.storeApi.getEmailIdByEmail(_account || '');
        const isSubAccount = !!subAccount;
        let token = '';
        if (isSubAccount && !process.env.BUILD_ISELECTRON) {
            token = this.mailConfApi.getTokenBySubAccount(subAccount);
        }
        for (let i = 0; i < entity.length; i++) {
            const it = entity[i];
            if (it && it.mid) {
                const { mid } = it;
                const mailModel = result.get(mid) || {};
                mailModel.id = mid;
                if (noCloudAttachment) {
                    it.attachment = it.attachment.filter(v => v.type !== 'netfolder');
                }
                if (it.attachment && it.attachment.length > 0) {
                    it.attachment.forEach(item => {
                        if (item.type !== 'netfolder') {
                            if (item.fileUrl) {
                                item.fileUrl = item.fileUrl.replace(/(\?|&|%3F|%26)sid(=|%3D)[0-9a-zA-Z*\-_.]+/gi, '$1sid$2' + currentUser.sessionId);
                            }
                            if (item.filePreviewUrl) {
                                item.filePreviewUrl = item.filePreviewUrl.replace(/(\?|&|%3F|%26)sid(=|%3D)[0-9a-zA-Z*\-_.]+/gi, '$1sid$2' + currentUser.sessionId);
                            }
                            if (token && item.fileUrl) {
                                item.fileUrl = item.fileUrl.replace(/(\?|&|%3F|%26)_token(=|%3D)[0-9a-zA-Z*\-_.]+/gi, '$1_token$2' + token);
                            }
                            if (token && item.filePreviewUrl) {
                                item.filePreviewUrl = item.filePreviewUrl.replace(/(\?|&|%3F|%26)_token(=|%3D)[0-9a-zA-Z*\-_.]+/gi, '$1_token$2' + token);
                            }
                        }
                        this.fileApi.registerTmpFile(item);
                    });
                }
                const entry = {
                    attachment: it.attachment,
                    attachmentCount: it.attachment.length,
                    isIcs: it.attachment.some(attaIt => {
                        var _a;
                        const { fileName } = attaIt;
                        if (fileName) {
                            return fileName.endsWith('.ics');
                        }
                        return (_a = attaIt === null || attaIt === void 0 ? void 0 : attaIt.contentType) === null || _a === void 0 ? void 0 : _a.includes('text/calendar');
                    }),
                };
                mailModel.isEncryptedMail = it.attachment ? getIsEncryptedMail(it.attachment) : false;
                mailModel.entry = Object.assign(Object.assign(Object.assign({}, defaultMailEntryInfo), mailModel.entry), entry);
                result.set(mid, mailModel);
            }
        }
    }
    buildMailModelByMailStatus(result, entity) {
        if (!entity || entity.length === 0) {
            return;
        }
        for (let i = 0; i < entity.length; i++) {
            const it = entity[i];
            if (it && it.mid) {
                const { mid } = it;
                const mailModel = result.get(mid) || {};
                mailModel.id = mid;
                mailModel.threadId = it.threadId;
                mailModel.updateTime = it.updateTime;
                mailModel.isOneRcpt = it.isOneRcpt;
                mailModel.tags = filterVisibleMailTags(it.tags);
                mailModel.headers = it.headers;
                const entry = {
                    top: it.rank === -10,
                    folder: it.folder,
                    mark: it.redFlag === 1 ? 'redFlag' : 'none',
                    readStatus: it.readStatus === 1 ? 'read' : 'unread',
                    replayed: it.replyStatus === 1,
                    requestReadReceiptLocal: it.requestReadReceiptLocal,
                    forwarded: it.forwardStatus === 1,
                    directForwarded: it.directForwardedStatus === 1,
                    rclStatus: it.rclStatus,
                    sndStatus: it.sndStatus,
                    memo: it.memo,
                    canRecall: it.canRecall,
                    threadMessageIds: it.threadMessageIds || [],
                    threadMessageCount: it.threadMessageCount || 0,
                    threadMessageFirstId: it.threadMessageFirstId || '',
                    receiveTime: util.dateFormatTo8(-it.sdTime),
                    sendTime: util.dateFormatTo8(-it.rcTime),
                    rcptCount: it.rcptCount,
                    sentMailId: it.sentMailId,
                    readCount: it.readCount,
                    innerCount: it.innerCount,
                    innerRead: it.innerRead,
                    preferred: it.preferred,
                    eTeamType: it.eTeamType || 0,
                    isDefer: it.isDefer === 1,
                    deferTime: it.deferTime ? moment(it.deferTime).format('YYYY-MM-DD HH:mm:ss') : '',
                    deferNotice: it.deferNotice === 1,
                    popRead: it.popRead === 1,
                    rcptFailed: it.rcptFailed === 1,
                    rcptSucceed: it.rcptSucceed === 1,
                    system: it.system === 1,
                    suspiciousSpam: !!it.suspiciousSpam,
                    tr_org_ec_id: it.tr_org_ec_id,
                    wmReply: it.wmReply,
                    mTrack: !!it.mTrack,
                };
                mailModel.convFids = Array.isArray(it.convFids) ? it.convFids : [];
                mailModel.entry = Object.assign(Object.assign(Object.assign({}, defaultMailEntryInfo), mailModel.entry), entry);
                result.set(mid, mailModel);
            }
        }
    }
    buildMailModelByMailData(result, entity, _account) {
        var _a, _b, _c, _d;
        if (!entity || entity.length === 0) {
            return;
        }
        const currentUser = this.systemApi.getCurrentUser(_account);
        for (let i = 0; i < entity.length; i++) {
            const it = entity[i];
            if (it && it.mid) {
                const { mid } = it;
                const mailModel = result.get(mid) || {};
                mailModel.isThread = !!it.isThread;
                mailModel.id = mid;
                mailModel.createTime = it.createTime;
                mailModel.taskId = it.taskId;
                mailModel._account = currentUser === null || currentUser === void 0 ? void 0 : currentUser.id;
                mailModel.authAccountType = ((_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.prop) === null || _a === void 0 ? void 0 : _a.authAccountType) || null;
                mailModel.mailIllegal = it.mailIllegal ? it.mailIllegal.split(',').map(v => +v) : undefined;
                if (it.scheduleDateTimeZone) {
                    mailModel.scheduleDateTimeZone = it.scheduleDateTimeZone;
                }
                if ((process.env.BUILD_ISEDM || ((_b = this.systemApi.doGetProductInfo()) === null || _b === void 0 ? void 0 : _b.navigateVersion)) && it.systemLabel && it.systemLabel.length) {
                    if (!mailModel.tags) {
                        mailModel.tags = [];
                    }
                    if (it.systemLabel.includes(3)) {
                        (_c = mailModel.tags) === null || _c === void 0 ? void 0 : _c.unshift('__deliveryrecord__');
                    }
                    if (it.systemLabel.includes(4)) {
                        (_d = mailModel.tags) === null || _d === void 0 ? void 0 : _d.unshift('__delivery__');
                    }
                }
                const entry = {
                    title: it.title,
                    sendTime: util.dateFormatTo8(-it.rcTime),
                    rcTime: it.rcTime,
                    receiveTime: util.dateFormatTo8(-it.sdTime),
                    id: mid,
                    attachmentCount: it.attachmentCount,
                    brief: it.brief,
                    priority: it.priority,
                    isScheduleSend: it.isScheduleSend || false,
                    tid: it.tid,
                    praiseId: it.praiseId,
                    sentMailId: it.sentMailId,
                    langType: it.langType || '',
                    langListMap: it.langListMap || {},
                    requestReadReceipt: it.requestReadReceipt,
                    linkAttached: !!it.linkAttached,
                    suspiciousSpam: !!it.suspiciousSpam,
                    size: it.size || 0,
                    encpwd: it.encpwd || '',
                    systemLabel: it.systemLabel || [],
                };
                mailModel.entry = Object.assign(Object.assign(Object.assign({}, defaultMailEntryInfo), mailModel.entry), entry);
                result.set(mid, mailModel);
            }
        }
    }
    async saveMailBoxes(items, _account, clearTable) {
        const targets = items.map(item => (Object.assign(Object.assign({}, item), { mailBoxUnread: item.mailBoxType === 'customer' ? 0 : item.mailBoxUnread, threadMailBoxUnread: item.mailBoxType === 'customer' ? 0 : item.threadMailBoxUnread })));
        if (clearTable) {
            try {
                await this.db.clear(Object.assign(Object.assign({}, mailBoxTable), { _dbAccount: _account }));
            }
            catch (e) {
                console.error('[DB saveMailBoxes clear error]', e);
            }
        }
        return this.db.putAll(Object.assign(Object.assign({}, mailBoxTable), { _dbAccount: _account }), targets);
    }
    splitThreadMails(mails) {
        return mails.reduce((total, v) => {
            if (!v.isThread) {
                return [...total, v];
            }
            const convFids = Array.isArray(v.convFids) ? v.convFids : [v.entry.folder];
            const children = convFids.map(fid => {
                const newId = util.getJointThreadId(v.id, fid);
                return Object.assign(Object.assign({}, v), { id: newId, entry: Object.assign(Object.assign({}, v.entry), { id: newId, folder: fid }) });
            });
            const threadMail = Object.assign(Object.assign({}, v), { entry: Object.assign(Object.assign({}, v.entry), { folder: mailBoxOfFakeThread.id }) });
            return [...total, ...children, threadMail];
        }, []);
    }
    async saveMails(mails, taskType = 'default', _account, attrConf) {
        var _a;
        const initialMail = Array.isArray(mails) ? mails : [mails];
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        const mailInfo = isCorpMail ? initialMail : this.splitThreadMails(initialMail);
        const mailData = new Map();
        const mailContent = new Map();
        const mailStatus = [];
        const mailAttachment = new Map();
        const mailAttachmentContent = [];
        const mailFiles = new Map();
        const idSet = new Set();
        const fileIdSet = new Set();
        const mailAttr = new Map();
        const localMailMap = new Map();
        try {
            const mailIds = Array.isArray(mails) ? mails.map(item => { var _a; return (_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.id; }) : [(_a = mails === null || mails === void 0 ? void 0 : mails.entry) === null || _a === void 0 ? void 0 : _a.id];
            let localMails = await this.db.getByIds(mailTable.data, mailIds, _account);
            localMails = localMails.filter(v => !!v);
            localMails.forEach(item => {
                if (item) {
                    localMailMap.set(item.id, item);
                }
            });
        }
        catch (e) {
            console.error(e);
        }
        mailInfo.forEach((it) => {
            var _a;
            if (it && it.id) {
                const mid = it.id;
                idSet.add(mid);
                const partInfo = this.modelHandler.isEntryContentEmpty(it);
                const titleMd5 = this.systemApi.md5(it.entry.title, true);
                const mstatus = this.buildMailStatusInfo(it, titleMd5);
                const localData = localMailMap.get(mid);
                const localAttFromContent = localData && (localData === null || localData === void 0 ? void 0 : localData.attSource) === 'content';
                const couldSaveAtt = ((_a = it === null || it === void 0 ? void 0 : it.entry) === null || _a === void 0 ? void 0 : _a.attSource) === 'content' || !(localData === null || localData === void 0 ? void 0 : localData.attSource) || !localAttFromContent;
                mailStatus.push(mstatus);
                if (attrConf) {
                    this.buildMailAttrInfo(it, attrConf, mailAttr);
                }
                const mdata = this.buildMailDataEntity(it, partInfo ? 0 : 1, titleMd5);
                mailData.set(mid, mdata);
                if (couldSaveAtt) {
                    const mAttachment = this.buildAttachmentInfo(it, titleMd5);
                    if (mAttachment) {
                        mailAttachment.set(mid, mAttachment);
                    }
                    this.mailAttachmentCacher.buildFileInfo(it, mailFiles, fileIdSet);
                    if (!partInfo) {
                        const mContent = this.buildMailContentEntity(it);
                        mailContent.set(mid, mContent);
                        if (mAttachment) {
                            mailAttachmentContent.push(mAttachment);
                            mailAttachment.delete(mid);
                        }
                    }
                }
            }
        });
        const statusPromise = this.putDataAndReserveFields({
            table: Object.assign(Object.assign({}, mailTable.status), { _dbAccount: _account }),
            idSet,
            data: mailStatus,
            reserveKeys: ['headers', 'threadId', 'attachmentsZipPath', 'convFids', 'threadMessageCount', 'threadMessageIds', 'requestReadReceiptLocal'],
        });
        const dataPromise = this.putIgnoreExist({
            table: Object.assign(Object.assign({}, mailTable.data), { _dbAccount: _account }),
            idSet,
            data: mailData,
            reserveKeys: [
                'brief',
                'tid',
                'fromEmail',
                'fromName',
                'toContactName',
                'toEmail',
                'sendersEmail',
                'isScheduleSend',
                'taskId',
                'linkAttached',
                'requestReadReceipt',
                'attSource',
            ],
        });
        const contentPromise = this.putIgnoreExist({
            table: Object.assign(Object.assign({}, mailTable.content), { _dbAccount: _account }),
            idSet,
            data: mailContent,
            reserveKeys: ['contentMd5', 'encoding'],
        });
        const attrPromise = this.putIgnoreExist({
            table: Object.assign(Object.assign({}, mailTable.attr), { _dbAccount: _account }),
            idSet: new Set(mailAttr.keys()),
            data: mailAttr,
            mapKey: 'aid',
        });
        const attachmentPromise = this.putIgnoreExist({
            table: Object.assign(Object.assign({}, mailTable.attachment), { _dbAccount: _account }),
            idSet,
            data: mailAttachment,
        });
        const attachmentContentPromise = this.db.putAll(Object.assign(Object.assign({}, mailTable.attachment), { _dbAccount: _account }), mailAttachmentContent);
        setTimeout(() => {
            this.mailAttachmentCacher
                .putFileIgnoreExist({
                idSet: fileIdSet,
                data: mailFiles,
                taskType,
                _account,
            })
                .catch(e => {
                console.error('[file auto download] error ', e);
            });
        });
        return Promise.all([statusPromise, dataPromise, contentPromise, attachmentPromise, attachmentContentPromise, attrPromise]);
    }
    async saveTpMails(mails) {
        const initialMail = Array.isArray(mails) ? mails : [mails];
        const listModels = initialMail.map(mail => ({
            mid: mail.id,
            owner: mail.owner || '',
            entryModel: Object.assign(Object.assign({}, mail), { entry: Object.assign(Object.assign({}, mail.entry), { content: Object.assign(Object.assign({}, mail.entry.content), { content: '' }) }) }),
            rcTime: -(util.parseDate(mail.entry.sendTime) || 0),
        }));
        const contentModels = initialMail
            .filter(v => { var _a, _b; return (_b = (_a = v.entry) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.content; })
            .map(mail => ({
            mid: mail.id,
            owner: mail.owner || '',
            entryModel: mail,
            rcTime: -(util.parseDate(mail.entry.sendTime) || 0),
        }));
        console.log('[tp mails] save to db list', listModels);
        console.log('[tp mails] save to db content', contentModels);
        await Promise.all([this.db.putAll(mailTable.tpMail, listModels), this.db.putAll(mailTable.tpMailContent, contentModels)]);
    }
    async collectExpiredMailIds() {
        const CLEAR_TARGET_TIMESTAMP = moment().subtract(30, 'day').valueOf();
        const idsInDeleted = await this.findExpiredMailIds(mailBoxOfDeleted.id, CLEAR_TARGET_TIMESTAMP);
        const idsInSpam = await this.findExpiredMailIds(mailBoxOfSpam.id, CLEAR_TARGET_TIMESTAMP);
        return [...idsInDeleted, ...idsInSpam];
    }
    async findExpiredMailIds(fid, expiredTimestamp) {
        const query = Object.assign({ start: 0, adCondition: {
                field: ['isThread', 'folder', 'rcTime'],
                type: 'between',
                args: [[0, fid, -expiredTimestamp], [0, fid, -0], true, true],
            } }, mailTable.status);
        const res = (await this.db.getByRangeCondition(query));
        res.forEach(v => {
            console.log('[mail clear]', fid, new Date(-v.rcTime).toLocaleString());
        });
        return res.filter(v => !!v).map(v => v.mid);
    }
    async checkAndSetClearFlag() {
        let needClear = true;
        const storeData = await this.storeApi.get(MailContentDbHelper.CLEAR_MAILS_KEY);
        if (storeData && storeData.data) {
            const CLEAR_INTERVAL = 24 * 60 * 60 * 1000;
            const lastCheckTimestamp = +storeData.data;
            needClear = Date.now() - lastCheckTimestamp >= CLEAR_INTERVAL;
        }
        if (needClear) {
            await this.storeApi.put(MailContentDbHelper.CLEAR_MAILS_KEY, String(Date.now()));
        }
        return needClear;
    }
    async saveThreadIds(mails, _account) {
        const map = new Map();
        mails.forEach(mail => {
            const { threadMessageIds } = mail.entry;
            if (mail.isThread && Array.isArray(threadMessageIds) && threadMessageIds.length > 0) {
                const threadId = mail.id;
                threadMessageIds.forEach(it => map.set(it, threadId));
            }
        });
        if (map.size > 0) {
            const mids = [...map.keys()];
            const allInfo = (await this.db.getByIds(mailTable.status, mids, _account)).filter(it => !!it);
            allInfo.forEach(it => {
                it.threadId = map.get(it.mid) || '';
            });
            console.log('[db] ==== insert into db for data of db: mailTable.status', allInfo);
            await this.db.putAll(mailTable.status, allInfo, undefined, _account);
        }
    }
    async putDataAndReserveFields({ table, idSet, data, reserveKeys }) {
        const ids = Array.from(idSet);
        const originData = (await this.db.getByIds(table, ids)).filter(v => !!v);
        const originMap = new Map();
        if (originData && originData.length > 0) {
            originData.forEach(it => !!it && !!it.mid && originMap.set(it.mid, it));
        }
        if (data.length > 0) {
            const remainData = [];
            data.forEach((v) => {
                const oData = originMap.get(v.mid);
                const { nv } = this.mergeAndTestData(v, oData, reserveKeys);
                remainData.push(nv);
            });
            return this.db.putAll(table, remainData);
        }
        return Promise.resolve([]);
    }
    mergeAndTestData(data, oData, reserveKeys = []) {
        const nv = Object.assign({}, data);
        let diff = false;
        if (reserveKeys && reserveKeys.length > 0 && oData) {
            reserveKeys.forEach(key => {
                if (oData[key] && nv[key] === undefined) {
                    nv[key] = oData[key];
                    diff = true;
                }
                else if (['requestReadReceiptLocal'].includes(key) && oData[key] !== undefined) {
                    nv[key] = oData[key];
                }
                else if (Array.isArray(oData[key]) && Array.isArray(nv[key])) {
                    diff = diff || util.isArrayDifferent(oData[key], nv[key]);
                }
                else if (oData[key] !== nv[key]) {
                    diff = true;
                }
                return diff;
            });
        }
        console.log('[db] insert into db for compare ' + reserveKeys.join(',') + '-> ' + diff, data, oData);
        return { nv, diff };
    }
    async putIgnoreExist({ table, idSet, data, reserveKeys, mapKey = 'mid' }) {
        if (data.size === 0) {
            return [];
        }
        const ids = Array.from(idSet);
        const originData = (await this.db.getByIds(table, ids)).filter(v => !!v);
        if (originData && originData.length > 0) {
            this.deleteExistData(mapKey, data, originData, reserveKeys);
        }
        if (data.size > 0) {
            const remainData = [];
            data.forEach(v => {
                remainData.push(v);
            });
            return this.db.putAll(table, remainData);
        }
        return Promise.resolve([]);
    }
    buildAttachmentInfo(it, titleMd5) {
        const mid = it.id;
        const { title } = it.entry;
        titleMd5 = titleMd5 || this.systemApi.md5(it.entry.title, true);
        if (it.entry.attachment && it.entry.attachment.length > 0) {
            return {
                mid,
                title,
                titleMd5,
                isThread: it.isThread ? 1 : 0,
                attachment: it.entry.attachment,
                attachmentNames: it.entry.attachment.map(attIt => attIt.fileName),
                changeAble: it.entry.folder === 2,
            };
        }
        return undefined;
    }
    buildMailStatusInfo(it, titleMd5) {
        var _a;
        const mid = it.id;
        const { title } = it.entry;
        titleMd5 = titleMd5 || this.systemApi.md5(it.entry.title, true);
        const rcTime = -(util.parseDate(it.entry.sendTime) || 0);
        const sdTime = -(util.parseDate(it.entry.receiveTime) || 0);
        const rank = it.entry.top ? -10 : it.entry.isScheduleSend ? -9 : 0;
        return {
            isThread: it.isThread ? 1 : 0,
            threadId: it.threadId || undefined,
            mid,
            convFids: Array.isArray(it.convFids) ? it.convFids : undefined,
            threadMessageFirstId: it.isThread && it.entry.threadMessageFirstId ? it.entry.threadMessageFirstId : undefined,
            threadMessageIds: it.isThread && it.entry.threadMessageIds ? it.entry.threadMessageIds : undefined,
            threadMessageCount: it.isThread ? it.entry.threadMessageCount : undefined,
            title,
            titleMd5,
            rank,
            folder: it.entry.folder,
            tags: it.tags,
            redFlag: it.entry.mark === 'redFlag' ? 1 : 0,
            readStatus: it.entry.readStatus === 'read' ? 1 : 0,
            requestReadReceiptLocal: it.entry.requestReadReceipt,
            sdTime,
            rcTime,
            updateTime: Date.now(),
            replyStatus: it.entry.replayed ? 1 : 0,
            forwardStatus: it.entry.forwarded ? 1 : 0,
            directForwardedStatus: it.entry.directForwarded ? 1 : 0,
            rclStatus: it.entry.rclStatus,
            sndStatus: it.entry.sndStatus,
            memo: it.entry.memo,
            canRecall: it.entry.canRecall ? 1 : 0,
            headers: it.headers,
            rcptCount: it.entry.rcptCount,
            readCount: it.entry.readCount,
            innerCount: it.entry.innerCount,
            innerRead: it.entry.innerRead,
            isOneRcpt: it.isOneRcpt,
            preferred: it.entry.preferred,
            eTeamType: it.entry.eTeamType || 0,
            isDefer: it.entry.isDefer ? 1 : 0,
            deferTime: it.entry.deferTime ? new Date(it.entry.deferTime).getTime() : undefined,
            deferNotice: it.entry.deferNotice ? 1 : 0,
            popRead: it.entry.popRead ? 1 : 0,
            rcptFailed: it.entry.rcptFailed ? 1 : 0,
            rcptSucceed: it.entry.rcptSucceed ? 1 : 0,
            suspiciousSpam: !!((_a = it.entry) === null || _a === void 0 ? void 0 : _a.suspiciousSpam),
            system: it.entry.system ? 1 : 0,
            sentMailId: it.entry.sentMailId,
            tr_org_ec_id: it.entry.tr_org_ec_id,
            wmReply: it.entry.wmReply || 0,
            mTrack: !!it.entry.mTrack,
        };
    }
    getMailAttrId(mid, attrValue, attrType) {
        return this.systemApi.md5(`${mid}${attrValue}${attrType}`, true);
    }
    getStarAttrValue(id, emailList) {
        return this.systemApi.md5(`${id}${emailList.join('')}`, true);
    }
    buildMailAttrInfo(it, attrConf, resMap) {
        const { id, isThread, entry: { sendTime, readStatus }, } = it;
        const { attrValue, attrType } = attrConf;
        if (id && !isThread) {
            const rcTime = -(util.parseDate(sendTime) || 0);
            const { from, to } = this.handleMailContact(it);
            const aid = this.getMailAttrId(id, attrValue, attrType);
            const value = {
                aid,
                attrType,
                attrValue,
                rcTime,
                mid: id,
                filterValues: {
                    from: Array.isArray(from) ? from : [from],
                    to: Array.isArray(to) ? to : [to],
                },
                readStatus: readStatus === 'unread' ? 0 : 1,
            };
            resMap.set(aid, value);
        }
        console.log('[mail attr]', resMap);
    }
    buildMailContentEntity(it, titleMd5) {
        var _a, _b, _c, _d;
        const mid = it.id;
        const { title } = it.entry;
        titleMd5 = titleMd5 || this.systemApi.md5(it.entry.title, true);
        const { cc, bcc, to, from, fromName, ccName, bccName, toName, all, } = this.handleMailContact(it);
        const content = (_a = it.entry.content) === null || _a === void 0 ? void 0 : _a.content;
        return {
            mid,
            title,
            titleMd5,
            isThread: it.isThread ? 1 : 0,
            contactData: all,
            fromEmail: from,
            fromName,
            toContactName: toName,
            ccContactName: ccName,
            bccContactName: bccName,
            toEmail: to,
            ccEmail: cc,
            bccEmail: bcc,
            brief: it.entry.brief,
            content,
            isHtml: (_b = it.entry.content) === null || _b === void 0 ? void 0 : _b.isHtml,
            contentId: (_c = it.entry.content) === null || _c === void 0 ? void 0 : _c.contentId,
            contentMd5: this.systemApi.md5(content, true),
            createTime: Date.now(),
            changeAble: it.entry.folder === 2,
            langType: it.entry.langType,
            langListMap: it.entry.langListMap,
            antispamInfo: it.antispamInfo,
            encoding: ((_d = it.entry.content) === null || _d === void 0 ? void 0 : _d.encoding) || 'default',
        };
    }
    buildMailDataEntity(it, allInfo, titleMd5) {
        var _a, _b;
        const mid = it.id;
        const { title } = it.entry;
        titleMd5 = titleMd5 || this.systemApi.md5(it.entry.title, true);
        const { to, toName, from, fromName, all, senders, sendersName } = this.handleMailContact(it);
        const sdTime = -(util.parseDate(it.entry.receiveTime) || 0);
        const rcTime = -(util.parseDate(it.entry.sendTime) || 0);
        const isEncryptedMail = it.entry.attachment ? getIsEncryptedMail(it.entry.attachment) : false;
        return {
            mid,
            title,
            titleMd5,
            isThread: it.isThread ? 1 : 0,
            attachmentCount: ((_a = it.entry.attachment) === null || _a === void 0 ? void 0 : _a.length) || 0,
            attSource: ((_b = it === null || it === void 0 ? void 0 : it.entry) === null || _b === void 0 ? void 0 : _b.attSource) || undefined,
            sdTime,
            rcTime,
            brief: it.entry.brief,
            contactData: all,
            fromEmail: from,
            fromName,
            toContactName: toName,
            toEmail: to,
            sendersEmail: senders,
            sendersName,
            isIcs: it.entry.isIcs,
            traceId: it.entry.traceId,
            taskId: it.taskId,
            suspiciousSpam: !!it.entry.suspiciousSpam,
            requestReadReceipt: it.entry.requestReadReceipt,
            allInfo,
            createTime: Date.now(),
            changeAble: it.entry.folder === 2,
            priority: it.entry.priority,
            isScheduleSend: it.entry.isScheduleSend || false,
            scheduleDateTimeZone: it.scheduleDateTimeZone,
            tid: it.entry.tid,
            praiseId: it.entry.praiseId,
            sentMailId: it.entry.sentMailId,
            langType: it.entry.langType,
            langListMap: it.entry.langListMap,
            linkAttached: it.entry.linkAttached,
            size: it.size,
            encpwd: it.entry.encpwd || '',
            systemLabel: it.entry.systemLabel || [],
            isEncryptedMail,
            mailIllegal: it.mailIllegal ? it.mailIllegal.join(',') : '',
        };
    }
    deleteExistData(mapKey, data, originData, reserveKeys) {
        originData.forEach(it => {
            const key = it[mapKey];
            if (!!it && !!key) {
                const target = data.get(key);
                if (target) {
                    let reserve = true;
                    if (reserveKeys && reserveKeys.length > 0) {
                        const { diff } = this.mergeAndTestData(target, it, reserveKeys);
                        if (!diff) {
                            reserve = false;
                        }
                    }
                    else {
                        reserve = false;
                    }
                    if (!reserve) {
                        data.delete(key);
                    }
                }
            }
        });
    }
    handleMailContact(item) {
        var _a, _b, _c, _d, _e, _f;
        const cc = [];
        const bcc = [];
        const to = [];
        const senders = [];
        const ccName = [];
        const bccName = [];
        const toName = [];
        const sendersName = [];
        const all = [];
        const from = (_b = (_a = item.sender) === null || _a === void 0 ? void 0 : _a.contactItem) === null || _b === void 0 ? void 0 : _b.contactItemVal;
        const fromName = ((_c = item.sender) === null || _c === void 0 ? void 0 : _c.originName) || ((_f = (_e = (_d = item.sender) === null || _d === void 0 ? void 0 : _d.contact) === null || _e === void 0 ? void 0 : _e.contact) === null || _f === void 0 ? void 0 : _f.contactName);
        item.receiver.forEach(it => {
            if (it) {
                const email = it.contactItem.contactItemVal;
                const name = it.originName || it.contact.contact.contactName;
                all.push({
                    name,
                    email,
                    type: it.mailMemberType,
                    item: '',
                });
                if (it.mailMemberType === 'to') {
                    to.push(email);
                    toName.push(name);
                }
                else if (it.mailMemberType === 'cc') {
                    cc.push(email);
                    ccName.push(name);
                }
                else if (it.mailMemberType === 'bcc') {
                    bcc.push(email);
                    bccName.push(name);
                }
            }
        });
        if (item.senders && item.senders.length > 1) {
            item.senders.forEach(it => {
                if (it) {
                    const email = it.contactItem.contactItemVal;
                    const name = it.originName || it.contact.contact.contactName;
                    all.push({
                        name,
                        email,
                        type: it.mailMemberType || '',
                        item: '',
                    });
                    senders.push(email);
                    sendersName.push(name);
                }
            });
        }
        if (from && fromName) {
            all.push({
                name: fromName,
                email: from,
                type: '',
                item: '',
            });
        }
        return {
            cc,
            bcc,
            to,
            from,
            senders,
            fromName,
            sendersName,
            ccName,
            bccName,
            toName,
            all,
        };
    }
    async getFirstMessageFromThreadMail(threadId, _account) {
        const threadMail = await this.getMailById({
            id: threadId,
            noContent: true,
            noContact: true,
            noAttachment: true,
            noData: true,
            _account,
        });
        if (!threadMail || threadMail.length === 0) {
            return Promise.reject(new Error('Not Found Thread Mail When Replay'));
        }
        const { threadMessageFirstId } = threadMail[0].entry;
        if (!threadMessageFirstId) {
            return Promise.reject(new Error('Not Found Thread Mail When Replay'));
        }
        return threadMessageFirstId;
    }
    getAllThreadIds(data, includeNormal = false) {
        const res = data.reduce((total, current) => {
            const { isThread, convFids, id, threadId } = current;
            if (isThread && Array.isArray(convFids) && convFids.length > 0) {
                convFids.forEach(fid => total.add(util.getJointThreadId(threadId, fid)));
                if (threadId) {
                    total.add(threadId);
                }
            }
            if (includeNormal) {
                total.add(id);
            }
            return total;
        }, new Set());
        return Array.from(res);
    }
    async doGetMailSearchRecords(count = 10, operationType, _account) {
        const res = await this.doGetMailOptRecords({ action: operationType, count }, _account);
        if (Array.isArray(res) && res.length > 0) {
            return res.map(v => ({
                id: v.oid,
                type: v.operationTitle || 'all',
                content: v.operationContent,
            }));
        }
        return [];
    }
    async doSaveMailSearchRecord(content, operationType, _account) {
        const operationRecords = content.map(it => {
            const now = -Date.now();
            return {
                operationType,
                createTime: now,
                updateTime: now,
                finishTime: now,
                operationContent: it.content,
                operationTitle: it.type,
                delFlag: 0,
            };
        });
        await this.db.putAll(mailOperationTable, operationRecords, undefined, _account);
    }
    async doGetMailOptRecords(params, _account) {
        return (await this.db.getByRangeCondition(Object.assign({ start: 0, count: params.count || 10, adCondition: {
                field: ['operationType', 'delFlag', 'createTime'],
                type: 'between',
                args: [[params.action, 0, -Number.MAX_VALUE], [params.action, 0, 0], true, true],
            } }, mailOperationTable), _account));
    }
    async updateMailSearchRecord(params, _account) {
        const result = (await this.db.getByIds(mailOperationTable, params.id, _account));
        if (Array.isArray(result) && result.length > 0) {
            result.forEach(v => {
                v.delFlag = params.deleteFlag;
            });
            this.db.putAll(mailOperationTable, result).then();
        }
    }
    deleteByIds(deletedIds, _account) {
        return Promise.all([
            this.db.deleteById(Object.assign(Object.assign({}, mailTable.status), { _dbAccount: _account }), deletedIds),
            this.db.deleteById(Object.assign(Object.assign({}, mailTable.content), { _dbAccount: _account }), deletedIds),
            this.db.deleteById(Object.assign(Object.assign({}, mailTable.data), { _dbAccount: _account }), deletedIds),
            this.db.deleteById(Object.assign(Object.assign({}, mailTable.attachment), { _dbAccount: _account }), deletedIds),
            this.deleteMailAttrByMids(deletedIds, _account),
        ]).catch(ex => {
            console.warn(ex);
        });
    }
    deleteTpMailsById(deletedIds) {
        return Promise.all([this.db.deleteById(Object.assign({}, mailTable.tpMail), deletedIds), this.db.deleteById(Object.assign({}, mailTable.tpMailContent), deletedIds)]).catch(ex => {
            console.warn(ex);
        });
    }
    deleteMailAttrByMids(mids, _account) {
        return this.db.deleteByByRangeCondition(Object.assign(Object.assign({ adCondition: {
                field: 'mid',
                args: [mids],
                type: 'anyOf',
            } }, mailTable.attr), { _dbAccount: _account }));
    }
    deleteTpMailsByOwner(owners) {
        const promises = [...new Set(owners)].reduce((t, v) => {
            const adCondition = {
                field: ['owner', 'rcTime'],
                args: [[v, -Number.MAX_VALUE], [v, 0], true, true],
                type: 'between',
            };
            const p1 = this.db.deleteByByRangeCondition(Object.assign({ adCondition }, mailTable.tpMail));
            const p2 = this.db.deleteByByRangeCondition(Object.assign({ adCondition }, mailTable.tpMailContent));
            return [...t, p1, p2];
        }, []);
        return Promise.all(promises).catch(e => {
            console.error('deleteTpMailsByOwner', e);
        });
    }
    deleteCustomerUnread(lastUpdateTime) {
        const adCondition = {
            field: ['type', 'updateTime'],
            args: [['customer', -Number.MAX_VALUE], ['customer', lastUpdateTime - 2000], true, true],
            type: 'between',
        };
        return this.db.deleteByByRangeCondition(Object.assign({ adCondition }, mailTable.statistic));
    }
    saveFilesInMail(taskEnable, taskType = 'default', _account) {
        return this.mailAttachmentCacher.saveFilesInMail(taskEnable || false, taskType, _account);
    }
    mkDownloadDir(type, config, fallbackToDefault) {
        return this.mailAttachmentCacher.mkDownloadDir(type, config, fallbackToDefault);
    }
    async doListStarContact(_account) {
        const currentUser = this.systemApi.getCurrentUser(_account);
        const res = await this.contactApi.doGetPersonalMarkList(undefined, undefined, { needMemberEmail: true }, _account);
        console.log('[star mail] star List from db', res);
        const starList = [];
        const addressContactMap = {};
        res.forEach((v, index) => {
            var _a;
            const mailBoxId = getFolderStartContactId(v === null || v === void 0 ? void 0 : v.value, v === null || v === void 0 ? void 0 : v.type);
            const parent = mailBoxOfStar.id;
            const star = {
                childrenCount: 0,
                _account: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id,
                authAccountType: (_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.prop) === null || _a === void 0 ? void 0 : _a.authAccountType,
                entry: {
                    deferCount: 0,
                    mailBoxName: v.name,
                    mailBoxCurrentUnread: v.unreadMailCount || 0,
                    mailBoxUnread: v.unreadMailCount || 0,
                    mailBoxTotal: 0,
                    mailBoxType: 'sys',
                    mailBoxId,
                    mailBoxParent: parent,
                    pid: parent,
                    threadMailBoxTotal: 0,
                    threadMailBoxUnread: v.unreadMailCount || 0,
                    threadMailBoxCurrentUnread: v.unreadMailCount || 0,
                    id: mailBoxId,
                    sort: index,
                },
                mailBoxId,
                children: [],
                starInfo: {
                    id: v.value,
                    type: +v.type === 1 ? 'personal' : 'org',
                    emailList: v.emails,
                },
            };
            starList.push(star);
            if (Array.isArray(v.emails) && v.emails.length > 0) {
                v.emails.forEach(email => {
                    if (!addressContactMap[email]) {
                        addressContactMap[email] = { contactsBelong: new Set([v.value]) };
                    }
                    else {
                        addressContactMap[email].contactsBelong.add(v.value);
                    }
                });
            }
        });
        return {
            starList,
            addressContactMap,
        };
    }
}
MailContentDbHelper.debugMailPopWindow = true;
MailContentDbHelper.translateSignTag = '<headm></headm>';
MailContentDbHelper.CLEAR_MAILS_KEY = 'clearMailLastCheck';
